/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_Source_Event_GroupInputs */



/**
* | output |
* | --- |
* | "Uploading source Event Group for translation" |
*
* @param {Uploading_Source_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_source_event_group = /** @type {((inputs?: Uploading_Source_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_Source_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléversement du groupe d’événements source pour la traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hochladen der Quellereignisgruppe zur Übersetzung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento del gruppo di eventi sorgente per la traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка исходной группы событий для перевода.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando el grupo de eventos de origen para su traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上传源事件组进行翻译")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳用のソースイベントグループをアップロードしています")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद के लिए स्रोत इवेंट समूह अपलोड किया जा रहा है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando o grupo de eventos de origem para tradução.")
	return /** @type {LocalizedString} */ ("Uploading source Event Group for translation")
});